import React, { Component, Suspense } from "react";
import { replacestate } from "./../../../redux_store/actions/index";
import store from "./../../../redux_store/store/index";
import { withTranslation } from "react-multi-lang";
import {
  defalutreduxState,
  isMultitenant,
} from "./../../../custom_functions/Constance.jsx";
import $ from "jquery";
import "bootstrap";
import { withAlert } from "react-alert";
import {
  Serviceuserworkflowdetails,
  Serviceprojectdetails,
  Serviceforuserrights,
  Serviceforauditconfig,
  updateActiveUserTime, setDateAsuserDefined, Getteamusersfromsession, Getuserprojectfromsession,
  Getuserworkflowfromsession,
  SubMenuRightsonScreenViews,
  getModuleRihtsOnOrderModule,
  Servicecallforuserrightscallback,
} from "./../../../custom_functions/Functions.jsx";
import Tabs, { TabPane } from "rc-tabs";
import { AtTabs } from "./../../../controls/custom-tabs.styles";
import "rc-tabs/assets/index.css";
import { NavLink, Redirect } from "react-router-dom";
import Service from "./../../general/Service.jsx";
// import { ControlRights } from "./../../../custom_functions/Functions.jsx";

const createHistory = React.lazy(() => import("./../../general/History.jsx"));

const Menu = React.lazy(() => import("./../../Menu.jsx"));
// const Protocolorder = React.lazy(() => import("./../../Protocolorders.jsx"));
const Protocolroderstructure = React.lazy(() => import("./../../orders/Protocolroderstructure.tsx"));
const ApplicationHeader = React.lazy(() =>
  import("./../../general/ApplicationHeader.jsx")
);
const ApplicationFooter = React.lazy(() =>
  import("./../../general/ApplicationFooter.jsx")
);
let filtertype = 2;
const protocoldaydiff = localStorage.getItem("protocolorderdatefilterdiff");
let daydiff = 7;
if (typeof protocoldaydiff === "string" && protocoldaydiff !== "NaN") {
  daydiff = parseInt(JSON.parse(protocoldaydiff));
}
// let diffdate = new Date().setDate(new Date().getDate() - daydiff);
const userDefinedDate = sessionStorage.userDefinedDate === "dd-MM-yyyy HH:mm:ss" || sessionStorage.userDefinedDate === "dd-MM-yy HH:mm:ss" || sessionStorage.userDefinedDate === "UTC Format" ? "YY/MM/DD HH:mm:ss" : sessionStorage.userDefinedDate;
const fromRange = filtertype === 1
  ? setDateAsuserDefined(
    new Date(
      new Date().setDate(new Date().setHours(0, 0, 0, 0)),
      sessionStorage.userDefinedDate
    )
  )
  : setDateAsuserDefined(
    new Date(new Date().setDate(new Date().getDate() - daydiff)),
    userDefinedDate
  )
const toRange = setDateAsuserDefined(new Date(), userDefinedDate)
export const MyprotocolFolderContext = React.createContext();

class PProtocolorders extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    let notificationprotocolorder = "";
    let isnotificationprotocolprocess = false;
    let notificationpreviouspath = undefined;
    if (
      props.location !== undefined &&
      props.location !== null &&
      props.location.state !== undefined &&
      props.location.state !== null &&
      JSON.stringify(props?.location?.state) !== "{}"
    ) {

      let notifiystate = JSON.parse(JSON.stringify(props.location.state));
      notificationpreviouspath = notifiystate.perviouspath;
      if (notifiystate?.Open_Type === undefined) {
        notificationprotocolorder =
          notifiystate.protocolordercode !== undefined
            ? notifiystate.protocolordercode
            : "";
        isnotificationprotocolprocess = notifiystate.isprotocolprocess
          ? notifiystate.isprotocolprocess
          : true;
      }

      setTimeout(() => {
        this.props.history.push("/Protocolorder");
      }, 100);
    }

    this.state = {
      validurl: true,
      idle_save: false,
      MenuGroup: "SheetView",
      ChildMenu: "SheetViewcss",
      PageName: isMultitenant === 2 ? this.props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS") : this.props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDER", {
        param: "",
      }),
      menuoption: 0,
      open: false,
      Menuselected: "",
      modalopen: false,
      ordercode: undefined,
      userrightdetails: undefined,
      notificationprotocolorderno: notificationprotocolorder,
      isnotificationprotocolprocess: isnotificationprotocolprocess,
      notificationpreviouspath: notificationpreviouspath,
      sheetordervisible: false,
      Protocolordervisible: false,
      protocolopen: false,
      notifiystate: props.location.state,
      ServiceToUrl: "",
      ServiceMethodType: "POST",
      ServiceHeaderobject: {},
      ServcieonSuccess: undefined,
      ServcieonFailure: undefined,
      isfolderresponse: false,
      screenname: "ProtocolOrder",
      Folders: { Material: [], Materialtest: [], directory: [], projects: [], tests: [] }
    };
    this.filtertype = localStorage.getItem("protocolorderdatefilterdiff") !== null && localStorage.getItem("protocolorderdatefilterdiff") !== undefined
      ? parseInt(localStorage.getItem("protocolorderdatefilterdiff")) : 2;
    this.MainMeunClick = this.MainMeunClick.bind(this);
    this.ELNurl = window.appUrl.ELN;


  }

  componentWillUnmount() {
    this._isMounted = false;
    Serviceuserworkflowdetails(
      "" + this.ELNurl +
      "/Instrument/Getuserworkflow",
      { usergroupcode: $.session.get("multiusergroups") }
    );
    Serviceprojectdetails(
      "" + this.ELNurl +
      "/Instrument/Getuserprojects",
      store.getState().Loggeduser
    );
    Serviceforuserrights(
      "" + this.ELNurl +
      "/User/GetUserRightsonUser",
      {
        usercode: $.session.get("User"),
        lsusergroup: { usergroupcode: $.session.get("multiusergroups") },
      }
    );
    Serviceforauditconfig(
      "" + this.ELNurl +
      "/AuditTrail/GetAuditconfigUser",
      {
        usercode: $.session.get("User"),
        lssitemaster: { sitecode: Number(sessionStorage.Usersite), sitename: sessionStorage.Usersitename },
        lsusergroup: { usergroupcode: $.session.get("multiusergroups") },
      }
    );
  }

  updateuserrights() {
    if (!store.getState().Menu?.Controlrights?.rights) {
      Servicecallforuserrightscallback("" + this.ELNurl + "/User/GetUserRightsonUser",
        {
          usercode: sessionStorage.User,
          lsusergroup: { usergroupcode: sessionStorage.multiusergroups },
        },
        () => this.setScreenView()
      );
    } else {
      this.setScreenView();
    }
  }

  setScreenView() {
    this.setState({
      validurl: SubMenuRightsonScreenViews("IDS_MDL_ORDERS", "IDS_SCN_PROTOCOLORDERS"),
      MenuGroup: "SheetView",
      PageName: this.props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDER", { param: "", }),
    })
  }

  componentDidMount() {
    updateActiveUserTime();

    this.updateuserrights();

    if (
      this.props.location.hash !== undefined &&
      this.props.location.hash.length > 0
    ) {
      let Sheetrun = this.props.location.hash.substring(
        2,
        this.props.location.hash.length - 1
      );
      if (
        Sheetrun !== undefined &&
        Sheetrun.split(":").length > 1 &&
        Sheetrun.split(":")[0] === "orderid"
      ) {
        let ordercode = Sheetrun.split(":")[1];
        this.setState({
          MenuGroup: "SheetView",
          PageName: this.props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDER", { param: "", }),
          Menuselected: "SheetView_menu_group",
          ordercode: ordercode,
        });
      }
    }
    // if ((this.props.location !== undefined && this.props.location.state !== undefined && Object.keys(this.props.location.state).length === 0) || (this.props.location !== undefined && this.props.location.state === undefined)) {
    if (!this.state.isnotificationprotocolprocess) {
      let passObj = {
        fromdate: new Date(fromRange),
        todate: new Date(toRange),
        lstproject: Getuserprojectfromsession(),
        lstworkflow: Getuserworkflowfromsession(),
        lsuserMaster: {
          usercode: parseInt(sessionStorage.User),
          username: sessionStorage.Username,
          unifieduserid: sessionStorage.unifieduserid,
          lssitemaster: { sitecode: $.session.get("Usersite") },
          ismultitenant: isMultitenant,
        },
        ismultitenant: isMultitenant,
      };
      passObj.lstuserMaster = Getteamusersfromsession();
      passObj.lsuserMaster.lsusergrouptrans = {
        usergroupcode: localStorage.getItem("multiusergroups"),
        usergroupname: localStorage.getItem("usergroupname"),
        usergroupstatus: localStorage.getItem("usergroupstatus"),
      };
      this.setState({
        ServiceToUrl: "" + this.ELNurl + "/Instrument/Getfoldersforprotocolorders",
        ServiceHeaderobject: passObj,
        ServiceMethodType: "POST",
        ServcieonSuccess: (response) => {
          this.setState({ Folders: response }, () => {
            this.protocolscreen = (<Suspense fallback={<div></div>}>
              <MyprotocolFolderContext.Provider value={{ "Folders": this.state.Folders, "isfolderresponse": true }}>
                <Protocolroderstructure
                  sessionvalues={{
                    usercode: $.session.get("User"),
                    username: $.session.get("Username"),
                    lssitemaster: { sitecode: $.session.get("Usersite") },
                    lsuserMaster: {
                      usercode: $.session.get("User"),
                      username: $.session.get("Username"),
                    },
                    ismultitenant: isMultitenant
                  }}
                  isnotificationprocess={this.state.notifiystate}
                  onresetnotification={this.onresetnotification.bind(this)}
                  onopen={this.onopen.bind(this)}
                  notificationpreviouspath={this.state.notificationpreviouspath}
                  isnotifify={this.state.isnotificationprotocolprocess}
                  idle_save={this.state.idle_save}
                /></MyprotocolFolderContext.Provider> </Suspense>)

          });
          this.setState({ isfolderresponse: true });
        },
        ServcieonFailure: () => { },
      });
    }
    else {
      this.protocolscreen = (<Suspense fallback={<div></div>}>
        <MyprotocolFolderContext.Provider value={{ "Folders": this.state.Folders, "isfolderresponse": true }}>
          <Protocolroderstructure
            sessionvalues={{
              usercode: $.session.get("User"),
              username: $.session.get("Username"),
              lssitemaster: { sitecode: $.session.get("Usersite") },
              lsuserMaster: {
                usercode: $.session.get("User"),
                username: $.session.get("Username"),
              },
              ismultitenant: isMultitenant
            }}
            isnotificationprocess={this.state.notifiystate}
            onresetnotification={this.onresetnotification.bind(this)}
            onopen={this.onopen.bind(this)}
            notificationpreviouspath={this.state.notificationpreviouspath}
            isnotifify={this.state.isnotificationprotocolprocess}
            idle_save={this.state.idle_save}
          /></MyprotocolFolderContext.Provider> </Suspense>);

      this.setState({ isfolderresponse: true });
    }
    // }
  }

  MainMeunClick(Menu) {
    let PageName = "";
    let open = false;
    if (Menu === "SheetCreation") {
      PageName = this.props.t("Templates.Sheettemplates.IDS_LBL_SHEETCREATION", {
        param: "",
      });
      open = false;
    } else if (Menu === "SheetView") {
      PageName = this.props.t("menu.IDS_REGORDEREXE", {
        param: "",
      });
      open = false;
    } else if (Menu === "SheetSetting") {
      PageName = this.props.t("menu.IDS_SHEETSETTING", {
        param: "",
      });
    } else if (Menu === "AuditTrail") {
      PageName = this.props.t("Audittrail.Audittrailhistory.IDS_LBL_AUDITTRAIL", {
        param: "",
      });
      open = false;
    } else if (Menu === "UserManagement") {
      PageName = this.props.t("UserManagement.ID_USERMANAGEMENT", {
        param: "",
      });
      open = false;
    } else if (Menu === "Dashboard") {
      PageName = this.props.t("Dashboard.IDS_LBL_DASHBOARD", {
        param: "",
      });
      open = false;
    } else if (Menu === "Masters") {
      PageName = this.props.t("Masters.ID_MASTERS", {
        param: "",
      });
      open = false;
    } else if (Menu === "DownloadReport") {
      PageName = this.props.t("Reports.IDS_LBL_SCREENNAME", {
        param: "",
      });
      open = false;
    } else if (Menu === "Protocals") {
      PageName = this.props.t("menu.IDS_PROTOCOLS", {
        param: "",
      });
      open = false;
    } else if (Menu === "Protocolorder") {
      PageName = this.props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDER", {
        param: "",
      });
      open = false;
    }

    this.setState({
      MenuGroup: Menu,
      PageName: PageName,
      open: open || true,
      Menuselected: "",
    });
  }

  ChilMenuclick(Menu) {
    this.setState({ ChildMenu: Menu });
  }

  idle_save() {
    this.setState({ idle_save: true }, () => {
      this.protocolscreen = (<Suspense fallback={<div></div>}>
        <MyprotocolFolderContext.Provider value={{ "Folders": this.state.Folders, "isfolderresponse": true }}>
          <Protocolroderstructure
            sessionvalues={{
              usercode: $.session.get("User"),
              username: $.session.get("Username"),
              lssitemaster: { sitecode: $.session.get("Usersite") },
              lsuserMaster: {
                usercode: $.session.get("User"),
                username: $.session.get("Username"),
              },
              ismultitenant: isMultitenant
            }}
            // isnotificationprocess={this.state.notifiystate}
            onresetnotification={this.onresetnotification.bind(this)}
            onopen={this.onopen.bind(this)}
            notificationpreviouspath={this.state.notificationpreviouspath}
            isnotifify={this.state.isnotificationprotocolprocess}
            idle_save={this.state.idle_save}
          /></MyprotocolFolderContext.Provider> </Suspense>);
      setTimeout(() => {
        this.setState({ rerender: !this.state.rerender, isfolderresponse: true })
      }, 100);
    })
  }

  onlogoutSuccess(response) {
    store.dispatch(replacestate(defalutreduxState));
    setTimeout(() => {
      let tenantdomain = $.session.get("tenantdomain");

      if (tenantdomain !== undefined) {
        isMultitenant === 0
          ? this.props.history.push("/")
          : this.props.history.push("/#" + tenantdomain);
        this.props.alert.success(this.props.t("Login.IDS_MSG_LOGOUT"));
      } else {
        this.props.history.push("/")
      }
    }, 100);
  }

  onlogoutFailure(response) { }

  // updateuserrights(screenrights) {
  //   let uOrders = ControlRights("IDS_MDL_ORDERS", "IDS_SCN_UNLOCKORDERS");
  //   this.setState({
  //     Unlockordervisible: uOrders.UserGroupRights.rights,
  //   });

  // }

  onredirectrights(objrights) {
    // let uOrders = ControlRights("IDS_MDL_ORDERS", "IDS_SCN_UNLOCKORDERS");
    this.setState({
      userrightdetails: objrights,
      sheetordervisible: SubMenuRightsonScreenViews("IDS_MDL_ORDERS", "IDS_SCN_SHEETORDERS"),
      Protocolordervisible: objrights.ProtocolOrder,
      Unlockordervisible: SubMenuRightsonScreenViews("IDS_MDL_ORDERS", "IDS_SCN_UNLOCKORDERS"),
    });
  }

  redirecttohome() {
    this.props.history.push("/Home");
  }

  onopen(openorder, Isopen
  ) {
    if (Isopen && openorder !== undefined) {
      this.setState({
        protocolopen: true,
        notifiystate: openorder
      })
    } else {
      this.setState({
        protocolopen: false,
        notifiystate: undefined
      })
    }
  }

  onresetnotification() {

    if (
      (this.props.location !== undefined &&
        this.props.location !== null &&
        this.props.location.state !== undefined &&
        this.props.location.state !== null) || (this.state.notifiystate !== undefined)
    ) {
      const history = createHistory;
      if (history.location !== undefined) {
        if (history.location.state && history.location.state.protocolordercode) {
          let state = { ...history.location.state };
          delete state.protocolordercode;
          history.replace({ ...history.location, state });
          this.setState({ notifiystate: state })
        }
      } else {
        this.setState({ notifiystate: undefined })
      }
    }
  }


  OnNotificationchange(data) {
    if (data !== null && data?.Open_Type !== undefined) {
      this.setState({ notifiystate: data })
    }

  }


  render() {
    if (!$.session.get("User")) {
      setTimeout(() => {
        let tenantdomain = $.session.get("tenantdomain");
        if (this.props && this.props.history) {
          if (tenantdomain !== undefined) {
            isMultitenant === 0
              ? this.props.history.push("/")
              : this.props.history.push("/#" + tenantdomain);
            this.props.history.go(1);
            // this.props.alert.success(this.props.t("Login.IDS_MSG_LOGOUT"));
          } else {
            this.props.history.push("/")
          }
        }
      }, 100);
      return <div></div>;
    }

    if (!this.state.validurl) {

      const getPath = getModuleRihtsOnOrderModule("IDS_MDL_ORDERS");
      console.log(getPath);

      let path = getPath?.path !== undefined ? getPath?.path : "/Home";

      return <Redirect to={path} />;
    }

    return (
      <div id="idElnBody">
        <Service
          Tourl={this.state.ServiceToUrl}
          MethodType={this.state.ServiceMethodType}
          onSuccess={this.state.ServcieonSuccess}
          onFailure={this.state.ServcieonFailure}
          Headerobject={this.state.ServiceHeaderobject}
          onReseturl={() => {
            this.setState({ ServiceToUrl: "" });
          }}
        ></Service>
        <Suspense fallback={<div></div>}>
          <Menu
            sendData={this.MainMeunClick}
            childmenuclick={this.ChilMenuclick.bind(this)}
            selected={this.state.Menuselected}
            menugroup={this.state.MenuGroup}
            screenname={this.state.screenname}
            redirectrights={this.onredirectrights.bind(this)}
          />
        </Suspense>
        <div id="bodycontent" className="d-flex flex-column">
          <div id="onremoveitems">
            <Suspense fallback={<div></div>}>
              <ApplicationHeader
                onlogoutSuccess={this.onlogoutSuccess.bind(this)}
                redirecttohome={this.redirecttohome.bind(this)}
                onlogoutFailure={this.onlogoutFailure.bind(this)}
                OnNotificationchange={this.OnNotificationchange.bind(this)}
                PageName={this.state.PageName}
              />
            </Suspense>
          </div>
          {/* <Suspense fallback={<div></div>}>
            <Protocolorder
              documentInfo={this.state.documentInfo}
              rights={this.state.userrightdetails}
              selectedprotocol={this.props.location.state}
            />
          </Suspense> */}
          <AtTabs id="tabclassname">
            <Tabs
              activeKey={"2"}
              // onTabClick={this.ontabclick}
              moreIcon={<span className="moreDot">...</span>}
            >
              {this.state.sheetordervisible ? (
                <TabPane
                  tab={
                    <NavLink
                      to={{ pathname: "/registertask" }}
                      title="Sheet orders"
                    >
                      {isMultitenant === 2 ? this.props.t("Orders.Sheetorders.IDS_LBL_LABSHEETTASKS") : this.props.t("Orders.Sheetorders.IDS_LBL_SHEET", {
                        param: "",
                      })}
                    </NavLink>
                  }
                  className="clstabcolor"
                  key="1"
                ></TabPane>
              ) : (
                ""
              )}
              {this.state.Protocolordervisible ? (
                <TabPane
                  tab={isMultitenant === 2 ? this.props.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS") : this.props.t("Orders.Protocolorders.IDS_LBL_PROTOCOL", {
                    param: "",
                  })}
                  key="2"
                >
                  {this.protocolscreen}
                </TabPane>
              ) : (
                ""
              )}
              {this.state.Unlockordervisible === true && isMultitenant !== 2 ? (
                <TabPane
                  tab={
                    <NavLink to={{ pathname: "/unlockorder" }}>
                      {this.props.t("Masters.Unlockorders.IDS_LBL_UNLOCKORDER")}
                    </NavLink>
                  }
                  key="3"
                ></TabPane>
              ) : (
                ""
              )}
            </Tabs>
          </AtTabs>
        </div>
        <Suspense fallback={<div></div>}>
          <ApplicationFooter
            onlogoutSuccess={this.onlogoutSuccess.bind(this)}
            onlogoutFailure={this.onlogoutFailure.bind(this)}
            onforgot={this.props.onforgot}
            idle_save={this.idle_save.bind(this)}
          />
        </Suspense>
      </div>
    );
  }
}
export default withAlert()(withTranslation(PProtocolorders));
